import styled, { keyframes, css } from 'styled-components';

/* ── paleta do design system ── */
const TEAL = 'var(--teal)';
const TEAL_LIGHT = 'var(--teal-light)';
const TEAL_SOFT = 'var(--teal-soft)';
const GRAY_BG = 'var(--bg)';
const GRAY_LINE = 'var(--line)';
const GRAY_TEXT = 'var(--text-muted)';
const GREEN = 'var(--green)';
const GREEN_SOFT = 'var(--green-soft)';
const RED = 'var(--red)';
const RED_SOFT = 'var(--red-soft)';
const AMBER = 'var(--amber, #d97706)';
const AMBER_SOFT = '#fdf2e0';
const BLUE = '#2a6fb0';
const BLUE_SOFT = '#e7f0f9';

const CORAL = 'var(--coral)';
const TEAL_GLOW = 'var(--teal-glow)';

const bp = { desktop: '1024px', tablet: '768px', mobile: '540px', small: '420px' };

const shimmer = keyframes`0% { background-position: -400px 0; } 100% { background-position: 400px 0; }`;
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: clip;
  background:
    radial-gradient(1200px 400px at 50% -120px, var(--bg-glow) 0%, transparent 70%),
    ${GRAY_BG};
  padding: 16px;
  @media (max-width: ${bp.tablet}) { padding: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 8px; }
`;

export const ContainerDivs = styled.div`
  width: 100%;
  max-width: 960px;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
`;

/* ── busca + filtros ── */
export const Search = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  gap: 14px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 16px 18px;
  animation: ${fadeUp} 0.35s ease;
  @media (max-width: ${bp.tablet}) { flex-direction: column; align-items: stretch; gap: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 14px; }
`;

export const FormSearch = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  label { color: ${GRAY_TEXT}; font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 7px 2px; }
`;

export const FormFilter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 260px;
  label { color: ${GRAY_TEXT}; font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 7px 2px; }
  @media (max-width: ${bp.tablet}) { max-width: 100%; }
`;

export const AreaEmp = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  &::before {
    content: '🔍';
    position: absolute;
    left: 12px;
    font-size: 14px;
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const InputEmp = styled.input`
  height: 44px;
  width: 100%;
  padding: 0 12px 0 36px;
  border: 1px solid ${GRAY_LINE};
  border-radius: 11px;
  font-size: 15px;
  font-family: inherit;
  background: ${GRAY_BG};
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
  box-sizing: border-box;
  &:focus {
    outline: none;
    background: var(--surface);
    border-color: ${TEAL_LIGHT};
    box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12);
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 44px;
  padding: 0 12px;
  border: 1px solid ${GRAY_LINE};
  border-radius: 11px;
  font-size: 15px;
  font-family: inherit;
  color: var(--text-2);
  background: ${GRAY_BG};
  cursor: pointer;
  transition: border-color .15s ease, box-shadow .15s ease;
  &:focus {
    outline: none;
    border-color: ${TEAL_LIGHT};
    box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12);
  }
`;

/* ── botão novo / carregar mais ── */
export const DivNewEmp = styled.div`
  display: flex;
  align-self: flex-end;
  @media (max-width: ${bp.mobile}) { align-self: stretch; }
`;

export const Btt02 = styled.button`
  padding: 11px 22px;
  background: ${TEAL};
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  box-shadow: 0 2px 8px ${TEAL_GLOW};
  transition: filter .15s ease, transform .12s ease;
  &:hover { filter: brightness(1.06); transform: translateY(-1px); }
  &:active { transform: translateY(0); }
  @media (max-width: ${bp.mobile}) { width: 100%; }
`;

/* botão "novo aluno" com o + */
export const AddBtn = styled(Btt02)`
  &::before { content: '＋'; font-size: 16px; }
`;

/* ── lista ── */
export const List = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 16px 18px;
  animation: ${fadeUp} 0.35s ease backwards;

  > p {
    font-size: 13px;
    font-weight: 700;
    color: ${GRAY_TEXT};
    margin: 0 2px 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    em { font-style: normal; color: ${CORAL}; font-weight: 700; }
  }
  @media (max-width: ${bp.mobile}) { padding: 14px; }
`;

export const Emp = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 16px;
  border: 1px solid ${GRAY_LINE};
  border-left: 3px solid ${TEAL};
  border-radius: 11px;
  cursor: pointer;
  background: var(--surface);
  transition: background .15s ease, transform .12s ease, box-shadow .15s ease, border-color .15s ease;
  animation: ${fadeUp} 0.3s ease backwards;
  &:hover {
    background: ${TEAL_SOFT};
    transform: translateX(3px);
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
    border-left-color: ${CORAL};
  }
  @media (max-width: ${bp.mobile}) { padding: 12px 14px; }
`;

export const EmpMain = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
  flex: 1;
`;

export const Avatar = styled.span`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_LIGHT} 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
`;

export const Span = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: ${bp.mobile}) { font-size: 14px; }
`;

/* badge multi-status (ativo/transferido/inativo/concluido) */
export const StatusBadge = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-radius: 999px;
  padding: 4px 11px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  &::before { content: '●'; font-size: 8px; }
  ${({ $tone }) => {
    switch ($tone) {
        case 'transferido': return css`background: ${AMBER_SOFT}; color: ${AMBER};`;
        case 'inativo': return css`background: ${RED_SOFT}; color: ${RED};`;
        case 'concluido': return css`background: ${BLUE_SOFT}; color: ${BLUE};`;
        default: return css`background: ${GREEN_SOFT}; color: ${GREEN};`; // ativo
    }
  }}
`;

export const LoadMoreText = styled.p`
  text-align: center;
  padding: 10px;
  color: ${GRAY_TEXT};
  font-size: 13px;
  font-weight: 600;
`;

export const EmptyState = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 16px;
  color: ${GRAY_TEXT};
  font-size: 14px;
  .em { display: block; font-size: 32px; margin-bottom: 8px; }
`;

/* ── skeleton ── */
const skeletonBase = css`
  background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.3s linear infinite;
  border-radius: 8px;
`;
export const SkeletonRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px 16px;
  border: 1px solid ${GRAY_LINE};
  border-left: 3px solid ${GRAY_LINE};
  border-radius: 11px;
  //.circle { ${skeletonBase} width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0; }
  //.bar { ${skeletonBase} height: 14px; flex: 1; }
  //.pill { ${skeletonBase} height: 20px; width: 70px; border-radius: 999px; flex-shrink: 0; }
`;